import { loadStripe } from "@stripe/stripe-js";
export const getStripeInstance = async stripeAccountId => {
  const instance = await loadStripe(process.env.REACT_APP_STRIPE_KEY, {
    stripeAccount: stripeAccountId,
  });
  return instance;
};
